const Loading = () => {
    return (
        <div className="h-screen flex justify-center items-center">
            <div className="loading">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}
export default Loading